// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import React from "react";
import styled from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-1k3dvqi-0"
})(["min-width:", ";max-width:", ";height:", ";"], ({
  $size
}) => $size, ({
  $size
}) => $size, ({
  $size
}) => $size);

/**
 * Return to previous page.
 *
 * @param {object} props - The component props
 * @param {string} [props.size] - The width/height of the icon as any CSS size unit
 * @param {string} [props.color] - The fill color of the icon as any CSS color value
 * @param {string} [props.title] - The title to add as a child of the root svg element
 *
 * @returns {React.ReactElement} - The ArrowBack component
 */
const ArrowBack = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/_jsxs(SVG, {
  ...props,
  $size: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation',
  children: [title ? /*#__PURE__*/_jsx("title", {
    children: title
  }) : null, " ", /*#__PURE__*/_jsx("path", {
    fill: color,
    d: "M4.438 10.856a.77.77 0 0 1 .097-.117l6.709-6.71a.755.755 0 0 1 1.065-.003.751.751 0 0 1-.005 1.064L6.6 10.795h11.647c.403 0 .744.335.744.75 0 .417-.333.75-.744.75H6.565l5.74 5.739a.755.755 0 0 1 .004 1.065.751.751 0 0 1-1.065-.005l-6.71-6.709a.757.757 0 0 1-.127-.169.755.755 0 0 1-.416-.671c0-.31.184-.574.447-.689z",
    children: " "
  })]
});
export default ArrowBack;